<div class="row" *ngIf="title !== undefined">
  <div *ngIf="!noTitle" class="col-4"><label>{{title}}</label></div>
  <div class="col-8">
    <div class="form-group">
      <select [ngClass]="(disabled)?'form-control form-control-sm nrk-disabled-background':'form-control form-control-sm'" [(ngModel)]="value" (change)="updateValue($any($event.target).value)" [attr.disabled]="disabled ? '' : null">
        <option *ngFor="let t of options" [value]="t[keyField]">{{t[displayField]}}</option>
      </select>
    </div>
  </div>
</div>
<div class="form-group" *ngIf="title === undefined">
  <select [ngClass]="(disabled)?'form-control form-control-sm nrk-disabled-background':'form-control form-control-sm'" [(ngModel)]="value" (change)="updateValue($any($event.target).value)" [attr.disabled]="disabled ? '' : null">
    <option *ngFor="let t of options" [value]="t[keyField]">{{t[displayField]}}</option>
  </select>
</div>
